import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["iconUrl"];
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import { MAGENTA } from 'ai-components-ui-library/styles/colors';
import { Image } from 'foundations-components/transitional/components/Image';
import styled from 'styled-components';
import Chiclet from './AIChiclet';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_ICON_SIZE = 20;
const SCALE_FACTOR = 0.6;
const IconContainer = styled.div.withConfig({
  displayName: "ToolChiclet__IconContainer",
  componentId: "sc-16os9uq-0"
})(["width:", "px;height:", "px;border-radius:50%;display:flex;align-items:center;justify-content:center;border:1px solid ", ";"], ({
  size
}) => size, ({
  size
}) => size, ({
  theme
}) => theme.color['border-tertiary-default']);
const ToolIcon = () => /*#__PURE__*/_jsx(UIIconCircle, {
  backgroundColor: MAGENTA[100],
  borderWidth: 0,
  color: MAGENTA[400],
  legacy: true,
  size: 10,
  name: "breezeSingleStar"
});
const IconUrlImage = ({
  iconUrl,
  size
}) => {
  const scaledSize = size * SCALE_FACTOR;
  return /*#__PURE__*/_jsx(IconContainer, {
    size: size,
    children: /*#__PURE__*/_jsx(Image, {
      src: iconUrl,
      height: scaledSize,
      width: scaledSize
    })
  });
};
const ToolChiclet = props => {
  const {
      iconUrl
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const Icon = iconUrl ? () => /*#__PURE__*/_jsx(IconUrlImage, {
    iconUrl: iconUrl,
    size: DEFAULT_ICON_SIZE
  }) : ToolIcon;
  return /*#__PURE__*/_jsx(Chiclet, Object.assign({}, rest, {
    icon: Icon
  }));
};
export default ToolChiclet;